export const wrapperIdentifier = 'eventTracker';
